export const isOperatorOrAbove = (role: string) => {
  const lowercaseRole = role.toLowerCase();
  return ['operator', 'teamlead', 'supervisor', 'director', 'admin'].some((testRole) => lowercaseRole.includes(testRole));
};
